export default __webpack_public_path__ + "static/media/image.cc30abd6.png";